import { ApiClient } from "./ApiClient";
import { isBrowser, Cookies } from "@pacerpro/utils";

export interface LocalSession {
  jwtToken: string;
  expiresAt: string;
}

const sessionsPath = "/api/v2/sessions";
const USER_SESSION = "user_session";
const XSRF_TOKEN = "XSRF-Token";

export const setLocalSession = (session: LocalSession) => {
  if (!isBrowser) return;
  try {
    localStorage.setItem(USER_SESSION, JSON.stringify(session));
  } catch (e) {
    console.warn("Unable to set local session");
  }
};

export const getLocalSession = () => {
  if (!isBrowser) return;
  const session = localStorage.getItem(USER_SESSION);
  return session ? JSON.parse(session) : { jwtToken: "", expiresAt: "" };
};

export const getJwtToken = () => {
  if (!isBrowser) return;
  return getLocalSession().jwtToken || "";
};

export const getSession = () => ApiClient().get(`${sessionsPath}/new`);

export const getXSRFToken = () => {
  if (!isBrowser) return;
  try {
    const token = Cookies.get(XSRF_TOKEN);
    if (token === "") {
      throw new Error(`XSRF Token is not set`);
    }
    return token;
  } catch (e) {
    console.warn("Unable to get XSRF Token ", e);
  }
};

export const clearLocalSession = () => {
  if (!isBrowser) return;
  try {
    localStorage.removeItem(USER_SESSION);
  } catch (e) {
    console.warn("Unable to clear local session.");
  }
};

export const signOut = () => ApiClient().delete(sessionsPath);
